<div class="dialog-content-max">
    <form [formGroup]="SubverticalForm">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="verticalid">{{this.verticalLabel}} Name<span class="required-label">*</span></label>
                <p-dropdown [options]="verticalList" [filter]="true" appendTo="body" optionLabel="name"
                    optionValue="verticalid" placeholder="Select {{this.verticalLabel}}" formControlName="verticalid"
                    inputId="verticalid" name="verticalid"></p-dropdown>
                <span style="color:red" class="errormessage"
                    *ngIf="SubverticalForm.get('verticalid').invalid && (SubverticalForm.get('verticalid').dirty || SubverticalForm.get('verticalid').touched)">
                    {{getErrorMessage(SubverticalForm ,validation_message,'verticalid')}}
                </span>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="subverticalname">{{this.subverticalLabel}} Name</label>
                <label for="pagemodal" class="required-label">
                    <span style="color: rgb(60, 137, 246);font-size:9px !important;">(Max 200 chars)</span><span class="required-label">*</span>
                </label>
                <textarea  autoResize="true" rows="3" class="form-control" id="subverticalname" inputId="subverticalname"
                    placeholder="Enter {{this.subverticalLabel}} Name" name="subverticalname" formControlName="subverticalname"
                    pInputText required></textarea>
                <!-- <span class="label-invalidmessage" *ngIf="SubverticalForm.get('subverticalname').invalid && SubverticalForm.get('subverticalname').touched ">
            {{getErrorMessage(SubverticalForm ,validation_message,'subverticalname')}}
       </span>   -->
                <span style="color:red" class="errormessage"
                    *ngIf="SubverticalForm.get('subverticalname').invalid && (SubverticalForm.get('subverticalname').dirty || SubverticalForm.get('subverticalname').touched)">
                    {{getErrorMessage(SubverticalForm ,validation_message,'subverticalname')}}
                </span>
            </div>
        </div>
    </form>
</div>
<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
    <p-button class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="addSubvertical()"></p-button>
</div>